// settings strings (es). Machine-drafted — review with a native speaker before launch.
const settings = {
	settings: {
		// Settings sidebar nav
		nav_yourProfile: 'Tu perfil',
		nav_billing: 'Facturación',
		nav_generateZapierKey: 'Generar clave de Zapier',
		nav_generateIntegrationKey: 'Generar clave de integración',
		nav_mcp: 'Asistentes de IA (MCP)',
		nav_referEarn: 'Recomienda y gana',
		nav_manageWorkspaces: 'Gestionar espacios de trabajo',
		nav_emailAccounts: 'Cuentas de correo',
		nav_basicSettings: 'Ajustes básicos',
		nav_teamMembers: 'Miembros del equipo',
		nav_previewCard: 'Vista previa de la tarjeta',
		nav_workspaceDomain: 'Dominio del espacio de trabajo',
		nav_videoCards: 'Tarjetas de video',
		nav_customDomainSettings: 'Ajustes de dominio personalizado',
		nav_personalization: 'Personalización',
		section_accountSettings: 'Ajustes de la cuenta',
		section_workspaceSettings: 'Ajustes del espacio de trabajo',
		section_whiteLabelSettings: 'Ajustes de marca blanca',

		// Shared dialog titles / statuses
		title_success: 'Éxito',
		title_error: 'Error',
		title_oops: '¡Ups!',
		title_warning: 'Advertencia',
		title_sorry: 'Lo sentimos',
		uploading: 'Subiendo...',

		// Basic Settings
		basicDetailsTitle: 'Detalles básicos',
		workspaceImageUpdated: 'La imagen del espacio de trabajo se ha actualizado.',
		workspaceName: 'Nombre del espacio de trabajo',
		timeZone: 'Zona horaria',
		saveUpdate: 'Guardar y actualizar',
		noWorkspace: 'Actualmente no tienes ningún espacio de trabajo',
		nothingToUpdate: 'Nada que actualizar.',
		changesSaved: 'Tus cambios se han guardado correctamente',
		somethingWrongSaving: 'Algo salió mal al guardar tus cambios.',

		// Custom Domain Settings
		domainTitle: 'Dominio',
		addCustomDomain: 'Añade tu dominio personalizado',
		whiteLabelRunDesc: 'Aquí es donde se ejecutará tu aplicación de marca blanca',
		howToSetupWhiteLabel: '¿Cómo configurar tu dominio de marca blanca?',
		domainName: 'Nombre del dominio',
		domainPlaceholder: 'app.ejemplo.io',
		saveDomain: 'Guardar dominio',
		cnameInstructions:
			'Para asignar un dominio personalizado a tu portal de soporte, asegúrate de haber añadido el siguiente registro CNAME en los ajustes de tu editor de zona DNS. Tu webmaster o administrador de servidor debería poder ayudarte a configurarlo.',
		tableType: 'Tipo',
		tableKey: 'Clave',
		tableValue: 'Valor',
		tableSslStatus: 'Estado SSL',
		tableConnectionStatus: 'Estado de conexión',
		statusActive: 'activo',
		statusInactive: 'inactivo',
		copy: 'copiar',
		cannotSaveHostDomain: 'No se pueden guardar dominios de host como dominio de marca blanca',

		// Manage Workspaces
		workspacesTitle: 'Espacios de trabajo',
		addNewWorkspace: 'Añadir nuevo espacio de trabajo',
		searchWorkspaces: 'Buscar espacios de trabajo',
		howToAddWorkspaces: '¿Cómo añadir nuevos espacios de trabajo a tu cuenta?',
		noWorkspacesToShow: 'No hay espacios de trabajo para mostrar.',
		maxLimitReached: 'Límite máximo alcanzado',
		maxWorkspaceLimit: 'Has alcanzado el límite máximo de espacios de trabajo para este plan',
		problemGettingWorkspaces: 'Se produjo un problema al obtener tus espacios de trabajo',

		// Invite member (workspace flow)
		inviteMemberTitle: 'Invitar miembro',
		workspaceDetails: 'Detalles del espacio de trabajo',
		inviteTeamMembers: 'Invitar miembros del equipo',
		inviteTeamMembersStep: 'Invitar miembros del equipo',
		addMoreMembersLater:
			'Siempre puedes añadir más miembros del equipo más tarde desde los ajustes del espacio de trabajo.',

		// New workspace detail
		newWorkspace: 'Nuevo espacio de trabajo',
		howToAddWorkspacesAccount: 'Cómo añadir nuevos espacios de trabajo a tu cuenta.',
		workspaceNamePlaceholder: 'El nombre de tu espacio de trabajo',
		saveNext: 'Guardar y continuar',

		// Workspace card
		selected: 'seleccionado',
		createdOn: 'Creado el:',
		remove: 'Eliminar',
		removeWorkspaceConfirm: '¿Seguro que quieres eliminar el espacio de trabajo?',
		cannotDeleteCurrent:
			'No se puede eliminar el espacio de trabajo seleccionado. Cambia a otro espacio de trabajo y luego elimínalo.',

		// Profile / Account
		accountTitle: 'Cuenta',
		deleteAccount: 'Eliminar cuenta',
		deleteAccountDesc:
			'Eliminar tu cuenta eliminará tu acceso y toda tu información en este sitio. ¿Seguro que quieres continuar?',
		updatedProfileSuccess: 'Perfil actualizado correctamente',
		accountDeletionTitle: 'Eliminación de cuenta',
		deleteAccountConfirm: '¿Quieres eliminar tu cuenta?',
		btnNo: 'No',
		btnYes: 'Sí',
		accountDeletedTitle: 'Cuenta eliminada',
		accountDeletedText: 'Tu cuenta se ha eliminado correctamente.',
		accountDeletionRelogin:
			'Si quieres eliminar tu cuenta, inicia sesión de nuevo y luego elimina tu cuenta.',

		// Basic profile fields
		firstName: 'Nombre',
		lastName: 'Apellido',
		email: 'Correo electrónico',
		emailCannotChange: 'El correo electrónico no se puede cambiar',

		// Change password
		currentPassword: 'Contraseña actual',
		invalidPassword: 'Contraseña no válida',
		newPassCannotSame: 'La nueva contraseña no puede ser la misma',
		confirmPassMismatch: 'La confirmación de la contraseña no coincide',

		// Team members
		membersTitle: 'Miembros',
		inviteMemberBtn: 'Invitar a un miembro',
		howToInviteMember: '¿Cómo invitar a un miembro del equipo a tu espacio de trabajo?',
		noTeamMembers: 'Actualmente no hay miembros del equipo en este espacio de trabajo.',
		errorDeletingMember: 'Se produjo un error al eliminar el miembro',
		deleteMemberConfirm: '¿Seguro que quieres eliminar el miembro?',
		invitationLinkGenerated: 'Se ha generado un enlace de invitación para %{email}',
		invitationLinkSent: 'Se ha enviado un enlace de invitación a %{email}',
		maxMembersReached: 'Has alcanzado el número máximo de miembros para tu plan',

		// Members card
		searchByNameEmail: 'Buscar por nombre y correo electrónico',
		inviteLinkCopied: 'Enlace de invitación copiado.',
		noSearchResults: 'No se encontraron resultados.',

		// Members table
		colName: 'Nombre',
		colRole: 'Rol',
		colStatus: 'Estado',
		colActions: 'Acciones',
		roleManager: 'Gerente',
		roleMember: 'Miembro',
		roleNotFound: 'Rol no encontrado',
		tooltipEditRole: 'Editar rol',
		tooltipDeleteMember: 'Eliminar miembro del equipo',
		tooltipCopyInviteLink: 'Copiar enlace de invitación.',

		// Invite member modal
		howToInviteWorkspace: '¿Cómo invitar a un miembro del equipo al espacio de trabajo?',
		placeholderFirstName: 'juan',
		placeholderLastName: 'pérez',
		placeholderEmailExample: 'juanperez@ejemplo.com',
		sendInvitation: 'Enviar invitación',
		ownerCannotInvite: 'El propietario no puede invitarse a sí mismo al espacio de trabajo.',
		memberEmailExists: 'Ya existe un miembro con este correo electrónico.',

		// Referral
		referAndEarn: 'Recomienda y gana',
		earnCommission: '¡Gana un 30% de comisiones recurrentes!',
		howItWorks: 'Así funciona nuestro programa de afiliados:',
		step1Join: '1. Únete',
		step2Refer: '2. Recomienda',
		step3Earn: '3. Gana',
		joinDesc: 'Regístrate en el programa de afiliados de CardClan.',
		referDesc: 'Comparte tu enlace de afiliado único con tus amigos y seguidores.',
		earnDesc: 'Recibe un 30% de comisión por cada venta que obtengamos de tu enlace de afiliado.',
		noteLabel: 'Nota: ',
		noteText:
			'No es solo ese pago único cuando se registran. Esa comisión del 30% se te pagará cada mes mientras su cuenta de CardClan esté activa.',
		becomeAffiliate: 'Conviértete en afiliado',
		createPromoter: 'Crear promotor',
		registerAffiliateDesc:
			'Usa el enlace de abajo para registrarte como afiliado de CardClan y empezar a promocionar.',
		createPromoterLink: 'Crear promotor',

		// Dropdown
		options: 'Opciones',

		// AI Assistants (MCP)
		mcp_title: 'Asistentes de IA (MCP)',
		mcp_description: 'Conecta Claude, Cursor, VS Code o cualquier asistente compatible con MCP a CardClan. Tu asistente podrá buscar tarjetas, enviarlas o programarlas a destinatarios, organizar carpetas e informar sobre la interacción, usando tu cuenta y los límites de tu plan.',
		mcp_keyTitle: 'Tu clave de API',
		mcp_keyDescription: 'El asistente se autentica con tu clave de API de CardClan (la misma que usan las integraciones).',
		mcp_keyWarning: 'Cualquiera con esta clave puede enviar tarjetas desde tu cuenta. Mantenla en secreto y no la pegues en documentos compartidos.',
		mcp_generateKey: 'Generar clave de API',
		mcp_show: 'Mostrar',
		mcp_hide: 'Ocultar',
		mcp_copy: 'Copiar',
		mcp_copied: 'Copiado al portapapeles',
		mcp_urlTitle: 'URL del servidor',
		mcp_urlDescription: 'El endpoint MCP de CardClan (Streamable HTTP).',
		mcp_setupTitle: 'Añade CardClan a tu asistente',
		mcp_setupDescription: 'Elige tu cliente y copia la configuración. El texto copiado incluye tu clave de API completa.',
		mcp_clientOther: 'Otros clientes',
		mcp_hint_claudeCode: 'Ejecuta este comando en tu terminal.',
		mcp_hint_claudeDesktop: 'Abre Ajustes → Desarrollador → Editar configuración, combina esto en claude_desktop_config.json y reinicia Claude Desktop. Requiere Node.js.',
		mcp_hint_cursor: 'Añade esto a ~/.cursor/mcp.json (o .cursor/mcp.json en un proyecto).',
		mcp_hint_vscode: 'Añade esto a .vscode/mcp.json en tu espacio de trabajo, o ejecuta “MCP: Add Server” desde la paleta de comandos.',
		mcp_hint_other: 'Funciona cualquier cliente que admita servidores MCP remotos por Streamable HTTP con un encabezado personalizado.',
		mcp_tryPrompt: 'Prueba a pedir: “Muestra mis tarjetas de CardClan y envía la tarjeta navideña a ann@example.com mañana a las 9”. Tu asistente previsualizará el envío y te preguntará antes de enviar correos.',
		mcp_toolsTitle: 'Lo que puede hacer tu asistente',
		mcp_toolsDescription: 'Las herramientas marcadas como “Puede hacer cambios” modifican tu cuenta o envían correos; la mayoría de asistentes piden tu aprobación antes de usarlas.',
		mcp_readOnly: 'Solo lectura',
		mcp_makesChanges: 'Puede hacer cambios',
		mcp_activityTitle: 'Actividad reciente',
		mcp_activityDescription: 'Cada acción realizada mediante MCP con tu clave de API. Se conserva 90 días.',
		mcp_activityTotal: '%{count} acciones en los últimos 90 días',
		mcp_activityEmpty: 'Aún no hay actividad. Cuando tu asistente esté conectado, sus acciones aparecerán aquí.',
		mcp_activityLoadFailed: 'No se pudo cargar la actividad de MCP.',
		mcp_refresh: 'Actualizar',
		mcp_loadMore: 'Cargar más',
		mcp_colTime: 'Hora',
		mcp_colTool: 'Acción',
		mcp_colResult: 'Resultado',
		mcp_colDuration: 'Duración',
		mcp_success: 'Correcto',
		mcp_failed: 'Error',
	} as Record<string, string>,
};
export default settings;
